import { gql } from '@apollo/client';

// Template Queries
export const LIST_WHATSAPP_TEMPLATES = gql`
  query ListWhatsappTemplates($data: ListWhatsAppTemplatesInputType) {
    list_whatsapp_templates(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_WHATSAPP_TEMPLATES_BY_AGENT = gql`
  query GetWhatsappTemplatesByAgent(
    $agent_id: ObjectId!
    $filters: TemplateFiltersInput
  ) {
    getWhatsappTemplatesByAgent(agent_id: $agent_id, filters: $filters) {
      _id
      template_id
      meta_template_name
      status
      category
      template_use
      created_at
      template {
        tbit_name
        language
        components
      }
    }
  }
`;

export const SYNC_WHATSAPP_TEMPLATES_STATUS = gql`
  mutation SyncWhatsappTemplatesStatus($agent_id: ObjectId!) {
    syncWhatsappTemplatesStatus(agent_id: $agent_id) {
      updated_count
      templates {
        _id
        status
        meta_template_name
        template_id
      }
    }
  }
`;

// Template Mutations
export const CREATE_WHATSAPP_TEMPLATE = gql`
  mutation CreateWhatsappTemplate($data: CreateWhatsappTemplateInputType!) {
    createWhatsappTemplate(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const UPDATE_WHATSAPP_TEMPLATE = gql`
  mutation UpdateWhatsappTemplate(
    $template_id: ObjectId!
    $input: UpdateWhatsappTemplateInput!
  ) {
    updateWhatsappTemplate(template_id: $template_id, input: $input) {
      _id
      status
      template {
        tbit_name
        components
      }
    }
  }
`;

export const DELETE_WHATSAPP_TEMPLATE = gql`
  mutation DeleteWhatsappTemplate($template_id: String!, $agent_id: String!) {
    deleteWhatsappTemplate(template_id: $template_id, agent_id: $agent_id) {
      data
      message
      hasError
    }
  }
`;

// Campaign Queries
export const GET_CAMPAIGNS_BY_AGENT = gql`
  query GetCampaignsByAgent(
    $agent_id: ObjectId!
    $filters: CampaignFiltersInput
  ) {
    getCampaignsByAgent(agent_id: $agent_id, filters: $filters) {
      _id
      name
      status
      template_id
      audience_id
      scheduled_at
      sent_count
      delivered_count
      read_count
      created_at
      template {
        meta_template_name
        template {
          tbit_name
        }
      }
      audience {
        name
        contact_count
      }
    }
  }
`;

export const GET_CAMPAIGN = gql`
  query GetCampaign($campaign_id: ObjectId!) {
    getCampaign(campaign_id: $campaign_id) {
      _id
      name
      status
      template_id
      audience_id
      scheduled_at
      sent_count
      delivered_count
      read_count
      click_count
      error_count
      created_at
      updated_at
      template {
        meta_template_name
        template {
          tbit_name
          components
        }
      }
      audience {
        name
        contact_count
        contacts
      }
    }
  }
`;

export const GET_CAMPAIGN_STATS = gql`
  query GetCampaignStats($campaign_id: ObjectId!) {
    getCampaignStats(campaign_id: $campaign_id) {
      sent_count
      delivered_count
      read_count
      click_count
      error_count
      delivery_rate
      read_rate
      click_rate
      error_rate
    }
  }
`;

// Campaign Mutations
export const CREATE_CAMPAIGN = gql`
  mutation CreateCampaign($input: CreateCampaignInput!) {
    createCampaign(input: $input) {
      _id
      name
      status
      template_id
      audience_id
      scheduled_at
    }
  }
`;

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign(
    $campaign_id: ObjectId!
    $input: UpdateCampaignInput!
  ) {
    updateCampaign(campaign_id: $campaign_id, input: $input) {
      _id
      name
      status
      scheduled_at
    }
  }
`;

export const EXECUTE_CAMPAIGN = gql`
  mutation ExecuteCampaign($campaign_id: ObjectId!) {
    executeCampaign(campaign_id: $campaign_id) {
      success
      message
      execution_id
    }
  }
`;

export const PAUSE_CAMPAIGN = gql`
  mutation PauseCampaign($campaign_id: ObjectId!) {
    pauseCampaign(campaign_id: $campaign_id) {
      success
      message
    }
  }
`;

export const RESUME_CAMPAIGN = gql`
  mutation ResumeCampaign($campaign_id: ObjectId!) {
    resumeCampaign(campaign_id: $campaign_id) {
      success
      message
    }
  }
`;

export const CANCEL_CAMPAIGN = gql`
  mutation CancelCampaign($campaign_id: ObjectId!) {
    cancelCampaign(campaign_id: $campaign_id) {
      success
      message
    }
  }
`;

export const DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($campaign_id: ObjectId!) {
    deleteCampaign(campaign_id: $campaign_id) {
      success
      message
    }
  }
`;

// Audience Queries
export const GET_AUDIENCES_BY_AGENT = gql`
  query GetAudiencesByAgent($agent_id: ObjectId!) {
    getAudiencesByAgent(agent_id: $agent_id) {
      _id
      name
      description
      contact_count
      created_at
      updated_at
    }
  }
`;

export const GET_AUDIENCE = gql`
  query GetAudience($audience_id: ObjectId!) {
    getAudience(audience_id: $audience_id) {
      _id
      name
      description
      contact_count
      contacts
      created_at
      updated_at
    }
  }
`;

// Audience Mutations
export const CREATE_AUDIENCE = gql`
  mutation CreateAudience($input: CreateAudienceInput!) {
    createAudience(input: $input) {
      _id
      name
      description
      contact_count
    }
  }
`;

export const UPDATE_AUDIENCE = gql`
  mutation UpdateAudience(
    $audience_id: ObjectId!
    $input: UpdateAudienceInput!
  ) {
    updateAudience(audience_id: $audience_id, input: $input) {
      _id
      name
      description
      contact_count
    }
  }
`;

export const DELETE_AUDIENCE = gql`
  mutation DeleteAudience($audience_id: ObjectId!) {
    deleteAudience(audience_id: $audience_id) {
      success
      message
    }
  }
`;

export const ADD_CONTACTS_TO_AUDIENCE = gql`
  mutation AddContactsToAudience($input: AddContactsToAudienceInput!) {
    addContactsToAudience(input: $input) {
      success
      message
      added_count
    }
  }
`;

export const IMPORT_CONTACTS_TO_AUDIENCE = gql`
  mutation ImportContactsToAudience($input: ImportContactsToAudienceInput!) {
    importContactsToAudience(input: $input) {
      success
      message
      imported_count
      errors
    }
  }
`;

// Media Upload for Templates
export const UPLOAD_MEDIA = gql`
  mutation UploadMedia($data: UploadMediaInputType!) {
    uploadMedia(data: $data) {
      hasError
      message
      data
    }
  }
`;

// Legacy support for existing components
export const SEND_CAMPAIGN = gql`
  mutation SendCampaign($data: SendCampaignInputType!) {
    send_campaign(data: $data) {
      hasError
      data
      message
    }
  }
`;

// Consent Management
export const CHECK_MARKETING_CONSENT = gql`
  query CheckMarketingConsent(
    $agent_id: ObjectId!
    $phone_numbers: [String!]!
  ) {
    checkMarketingConsent(agent_id: $agent_id, phone_numbers: $phone_numbers) {
      phone_number
      has_consent
      consent_date
      consent_source
    }
  }
`;

export const UPDATE_MARKETING_CONSENT = gql`
  mutation UpdateMarketingConsent($input: UpdateMarketingConsentInput!) {
    updateMarketingConsent(input: $input) {
      success
      message
      updated_count
    }
  }
`;

export const BULK_OPT_OUT = gql`
  mutation BulkOptOut($input: BulkOptOutInput!) {
    bulkOptOut(input: $input) {
      success
      message
      opted_out_count
    }
  }
`;

// Coupon Queries
export const VALIDATE_COUPON_CONFIG = gql`
  query ValidateCouponConfig($data: ValidateCouponInputType!) {
    validateCouponConfig(data: $data) {
      hasError
      message
      data {
        valid
        error
      }
    }
  }
`;

// Coupon Mutations
export const CREATE_COUPON = gql`
  mutation CreateCoupon($data: CreateCouponInputType!) {
    createCoupon(data: $data) {
      hasError
      message
      data {
        success
        coupon_code
        discount_id
      }
    }
  }
`;
